// simplified adaptation of geojson-polyline https://github.com/barberboy/geojson-polyline

import polyline from '@mapbox/polyline';
import type {Position} from 'geojson';

/**
 * Encodes a GeoJSON LineString or MultiLineString geometry as a polyline.
 */
export function lineStringToPolyline(
    geoJSON: GeoJSON.LineString | GeoJSON.MultiLineString,
    precision?: number
) {
    switch (geoJSON.type) {
        case 'LineString': {
            return Object.assign({}, geoJSON, {
                coordinates: encode(geoJSON.coordinates, precision),
            });
        }
        case 'MultiLineString': {
            return Object.assign({}, geoJSON, {
                coordinates: geoJSON.coordinates.map((coords) => {
                    return encode(coords, precision);
                }),
            });
        }
        default: {
            throw Error('GeoJSON type must be either LineString or MultiLineString');
        }
    }
}

/**
 * Decode a polyline-encoded GeoJSON LineString or MultiLineString geometry.
 */
export function polylineToLineString(
    poly: {
        type: 'LineString' | 'MultiLineString';
        coordinates: any;
    },
    precision?: number
) {
    switch (poly.type) {
        case 'LineString': {
            return Object.assign({}, poly, {
                coordinates: decode(poly.coordinates, precision),
            });
        }
        case 'MultiLineString': {
            return Object.assign({}, poly, {
                coordinates: poly.coordinates.map((coords: string) => {
                    return decode(coords, precision);
                }),
            });
        }
        default: {
            throw Error('Polyline type must be either LineString or MultiLineString');
        }
    }
}

function encode(coordinates: Position[], precision?: number) {
    return polyline.encode(flip(coordinates), precision);
}
function decode(str: string, precision?: number) {
    return flip(polyline.decode(str, precision));
}
function flip(coords: any[]) {
    const flipped = [];
    for (let i = 0; i < coords.length; i++) {
        flipped.push(coords[i].slice().reverse());
    }
    return flipped;
}
